export default () =>{

    const casitaImages = document.querySelectorAll('[casita-item-img]');

    casitaImages.forEach(img =>{
        const fotoViewButton = img.querySelector('[foto-view]');
        const topViewButton = img.querySelector('[top-view]');

        const image = img.querySelectorAll('.img');

        fotoViewButton.addEventListener('click', ()=>{
            image.forEach(el =>{
                el.classList.toggle('hidden')
            })
            topViewButton.classList.toggle('active');
            fotoViewButton.classList.toggle('active');
        })
        topViewButton.addEventListener('click', ()=>{
            image.forEach(el =>{
                el.classList.toggle('hidden')
            })
            topViewButton.classList.toggle('active');
            fotoViewButton.classList.toggle('active');
        })
    })
}